import { render, staticRenderFns } from "./AddressFormView.vue?vue&type=template&id=d35b3096&"
import script from "./AddressFormView.vue?vue&type=script&lang=js&"
export * from "./AddressFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports